<template>
  <div class="pop-select-item">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.pop-select-item {
  height: 0.91rem;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffe8a3;
  border-radius: 0.1rem;
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 0.2rem;
  color: #000000;
}
</style>
